
import { defineComponent } from 'vue'
import ModalContentMixin from '@/components/cv/modal/ModalContentMixin.vue'

export default defineComponent({
  mixins: [ModalContentMixin],
})
